import CAMION from "../assets/camion.svg";

const Solicitar = () => {
  return (
    <div className="w-full">
      {/* Camión */}
      <img src={CAMION} alt="camion" className="w-full md:w-1/2 mx-auto" />
<div className="w-full bg-gray-200 flex flex-col items-center py-6">
      {/* Títulos */}
      <h3 className="text-sky-500 font-semibold text-lg">Solicitar</h3>
      <h2 className="text-2xl md:text-3xl text-sky-800 font-bold mb-2">
        Presupuesto gratuito
      </h2>
      <p className="text-gray-500 mb-8 text-center max-w-xl">
        Completa el siguiente formulario y uno de nuestros asesores se pondrá en
        contacto contigo para brindarte un presupuesto sin compromiso.
      </p>

      {/* FORM */}
      <form className="w-full max-w-lg bg-white shadow-md rounded-xl p-6 flex flex-col gap-4">
        <input
          type="text"
          placeholder="Nombre completo"
          className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="email"
          placeholder="Correo electrónico"
          className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="tel"
          placeholder="Teléfono"
          className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="text"
          placeholder="Ciudad desde la que escribe"
          className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <textarea
          rows="4"
          placeholder="Mensaje"
          className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400 resize-none"
        ></textarea>

        <button
          type="submit"
          className="w-full bg-sky-700 text-white py-3 rounded-full font-semibold hover:bg-sky-800 transition"
        >
          Enviar solicitud
        </button>
      </form>
      </div>
    </div>
  );
};

export default Solicitar;
